export const PAYOUT_TYPES = {
    COD: "cod",
    CLAIM: "claim",
}

export const PAYOUT_TYPE_MAP = {
    [PAYOUT_TYPES.CLAIM]: { label: "CLAIM", color: "purple" },
    [PAYOUT_TYPES.COD]: { label: "COD", color: "orange" },
}

export const PAYOUT_TYPE_OPTIONS = [
    { value: PAYOUT_TYPES.COD, label: "COD" },
    { value: PAYOUT_TYPES.CLAIM, label: "Claim" },
]